<template>
    <div class="main-area">
        <el-breadcrumb separator=":">
            <el-breadcrumb-item>当前位置</el-breadcrumb-item>
            <el-breadcrumb-item>通知公告详情</el-breadcrumb-item>
        </el-breadcrumb>

        <el-row class="margin-top-10">
            <el-col :span="2" class="margin-top-10">
                <label class="search-label">
                栏目名称:
                </label>
            </el-col>
            <el-col :span="4" class="margin-top-10">
                <el-input v-model="searchForm.tztgUuidName"
                        :size="GLOBAL.config.systemSize"
                        placeholder="栏目名称"
                        clearable
                        maxlength="32"></el-input>
            </el-col>
            <el-col :span="2" class="margin-top-10">
                <label class="search-label">
                标题:
                </label>
            </el-col>
            <el-col :span="4" class="margin-top-10">
                <el-input v-model="searchForm.title"
                        :size="GLOBAL.config.systemSize"
                        placeholder="标题"
                        clearable
                        maxlength="32"></el-input>
            </el-col>
            <el-col :span="2" class="margin-top-10">
                <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询
                </el-button>
            </el-col>
        </el-row>

        <el-row class="margin-top-20">
            <el-col :span="24">
                <el-button v-if="source.add"
                        type="primary"
                        icon="el-icon-plus"
                        :size="GLOBAL.config.systemSize"
                        style="float: left;"
                        @click="operationMethod('add')">新增
                </el-button>
            </el-col>
        </el-row>

        <el-table style="width: 100%"
            :data="tableData"
            element-loading-text="数据处理中...请稍等..."
            v-loading="loading">
            <!--序号-->
            <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
            <el-table-column label="栏目名称" prop="tztgUuidName" align="center"></el-table-column>
            <el-table-column label="标题" prop="title" align="center"></el-table-column>
            <el-table-column label="所属区划" prop="ssqhdmName" align="center"></el-table-column>
            <!-- <el-table-column label="是否签收" prop="sfqs" align="center"></el-table-column> -->
            <el-table-column label="是否签收" prop="sfqs" align="center">
                <template slot-scope="scope" >
                    <span>{{scope.row.sfqs == '0' ? '需签收' : '不需签收'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="cjsj" label="创建时间" align="center" :formatter="formatterTime"/>
            <el-table-column prop="scope" label="操作" align="center">
                <template slot-scope="scope">
                    <el-dropdown>
                            <span class="el-dropdown-link operator-text">
                            选择操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                        <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :icon="item.icon" v-for="item in getSource(scope.row)"
                                            :key="item.method"
                                            @click.native="handleCommon(item.method, scope.row)">
                            {{item.title}}
                        </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            class="margin-top-10 margin-bottom-20"
            @size-change="tableSizeChange"
            @current-change="currentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizeList"
            :page-size="pagination.pageSize"
            :layout="pagination.layout"
            :total="pagination.total">
        </el-pagination>

        <NoticeDetailDialog ref="noticeDetailDialog" :refresh="init" :close-self="()=> viewVisibleFlag = false" />
      <el-dialog
        title="通知明细"
        :visible.sync="showFlag"
        @close="closeDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false">
        <div style="width: 100%; border: 1px solid #e5e5e5">
          <p>栏目名称：{{tzDetails.tztgUuidName}}</p>
          <p>标题：{{tzDetails.title}}</p>
          <p>{{tzDetails.nr}}</p>
        </div>
        <el-divider content-position="left">接收人</el-divider>
        <el-table style="width: 100%"
                  :data="peopleTableData"
                  element-loading-text="数据处理中...请稍等..."
                  v-loading="loading">
          <!--序号-->
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
          <el-table-column label="所属区划" prop="acceptSsqumaName" align="center"></el-table-column>
          <el-table-column label="接收人" prop="acceptName" align="center"></el-table-column>
          <el-table-column label="是否签收" prop="sfqs" align="center">
            <template slot-scope="scope" >
              <span>{{scope.row.sfqs == '0' ? '需签收' : '不需签收'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="签收状态" prop="wqs" align="center">
            <template slot-scope="scope" >
              <span>{{(scope.row.sfqs=='0' && scope.row.wqs == '0') ? '未签收' : (scope.row.sfqs=='0' && scope.row.wqs == '1'?'已签收': '')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="sfyd" align="center">
            <template slot-scope="scope">
              {{scope.row.sfyd=='1'?'未读':'已读'}}
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="margin-top-10 margin-bottom-20"
          @size-change="tableSizeChangePeople"
          @current-change="currentChangePeople"
          :current-page="peoplePagination.currentPage"
          :page-sizes="peoplePagination.pageSizeList"
          :page-size="peoplePagination.pageSize"
          :layout="peoplePagination.layout"
          :total="peoplePagination.total">
        </el-pagination>
      </el-dialog>
    </div>
</template>

<script>
import NoticeDetailDialog from './NoticeDetailDialog'
export default {
    name: 'NoticeDetailTable',

    components: {
        NoticeDetailDialog
    },

    data() {
        return {
            searchForm: {
                title: '',
                tztgUuidName: '',
                tztgUuid: ''
            },
            source: {
                add: true,
                deleteBatch: true,
                export: true,
                import: true,
                infoView: true,
                infoEdit: true,
                infoDelete: true,
                exportTemplate: true,
                upEdit: true
            },
            loading: false,
            tableData: [],
            // 分页参数
            pagination: {
                pageSizeList: [10, 20, 30, 40, 50],
                pageSize: 10,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0,
                currentPage: 1
            },
            showFlag: false,
            tzDetails: {},
            peopleTableData: [],
            // 接收人分页参数
            peoplePagination: {
                pageSizeList: [10, 20, 30, 40, 50],
                pageSize: 10,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0,
                currentPage: 1
            },
        }
    },

    methods: {
        doSearch: function () {
            this.searchForm.tztgUuid = ''
            this.getTableData('init')
        },
        init: function () {
            this.getTableData('init')
        },
        // 新增
        operationMethod(addInfo, info) {
            this.$refs.noticeDetailDialog.open(addInfo, info)
        },
        closeDialog: function () {
            this.showFlag = false
        },
        // 获取操作展示
        getSource: function (rowData) {
            let tempList = []
            this.source.infoView && tempList.push({icon: 'el-icon-view', title: '查看', method: 'handleView'})
            // this.source.infoEdit && tempList.push({icon: 'el-icon-edit', title: '编辑', method: 'handleEdit'})
            this.source.infoDelete && tempList.push({icon: 'el-icon-delete', title: '删除', method: 'handleDelete'})
            // if (rowData.sfqs == '0' && rowData.wqs == '0') {
            //     tempList.push({icon: 'el-icon-edit-outline', title: '签收', method: 'handleSign'});
            // }
            this.source.upEdit && tempList.push({icon: 'el-icon-top', title: '置顶', method: 'upEdit'})
            return tempList
        },
        handleCommon: function (type, rowData) {
            switch (type) {
                case 'handleView':
                    this.handleView(rowData)
                    break
                case 'handleEdit':
                    this.handleEdit(rowData)
                    break
                case 'handleDelete':
                    this.handleDelete(rowData)
                    break
                case 'handleSign':
                    this.handleSign(rowData);
                    break;
                case 'upEdit':
                    this.upEdit(rowData);
            }
        },
        handleView(rowData) {
            this.tzDetails = rowData
            this.peopleTableData = []
            this.getTzPeople(rowData.uuid, 'init')
            this.showFlag = true
        },
        handleEdit(rowData) {
            this.$refs.noticeDetailDialog.open('edit', rowData)
        },
        handleDelete(rowData) {
            let _this = this
            let param = {
                info: rowData.uuid,
                baseService: 'TGcTztgDetailsServiceImpl',
                type: 'deleteLogical'
            }
            _this.$confirm('是否删除当前数据？？', '提示', {
            }).then(() => {
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false
                        if (resultData) {
                            _this.$message.success('删除成功～')
                            _this.getTableData('init')
                        } else {
                            _this.$message.warning('删除失败～')
                        }
                    }
                )
            })
        },
        // 获取通知接受人
        getTzPeople(uuid,initPageFlag) {
            let _this = this;
            // 3、 调接口获取数据
            let paginationData = _this.FUNCTIONS.systemFunction.paginationSet(
                initPageFlag ? 1 : _this.peoplePagination.currentPage,
                initPageFlag ? 10 : _this.peoplePagination.pageSize,
                {gltgUuid: uuid})
            paginationData.baseService = "TGcTztgJsdxServiceImpl",
                _this.FUNCTIONS.systemFunction.interactiveData(
                    _this,
                    _this.GLOBAL.config.businessFlag.zxUser,
                    'getPage',
                    paginationData,
                    null,
                    resultData => {
                        _this.loading = false
                        if (resultData) {
                            // 结果参数赋值
                            _this.peopleTableData = resultData.obj.records;
                            _this.peoplePagination.pageSize = resultData.obj.size
                            _this.peoplePagination.total = resultData.obj.total
                            _this.peoplePagination.currentPage = resultData.obj.current
                        } else {
                            _this.$message.warning('获取接收人数据失败～')
                        }
                    },
                    () => {
                        _this.$message.error('获取接收人数据失败～请联系管理员')
                    }
                )
        },
        // 签收
        handleSign(rowData) {
            let _this = this
            let param = {
                info: {uuid: rowData.uuid, type: '1'},
                baseService: 'TGcTztgDetailsServiceImpl',
                // baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
                type: 'updateZt'
            }
            _this.$confirm('确认签收当前数据？？', '提示', {
            }).then(() => {
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false
                        if (resultData) {
                            _this.$message.success('操作成功～')
                            _this.getTableData('init')
                        } else {
                            _this.$message.warning('操作失败～')
                        }
                    }
                )
            })
        },
        // 置顶
        upEdit(rowData) {
            let _this = this
            let param = {
                info: {uuid: rowData.uuid, type: '3'},
                baseService: 'TGcTztgDetailsServiceImpl',
                // baseService: _this.GLOBAL.config.baseServiceType.TGcGcdaServiceImpl,
                type: 'updateZt'
            }
            _this.$confirm('确认置顶当前数据？？', '提示', {
            }).then(() => {
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    param,
                    resultData => {
                        _this.loading = false
                        if (resultData) {
                            _this.$message.success('操作成功～')
                            _this.getTableData('init')
                        } else {
                            _this.$message.warning('操作失败～')
                        }
                    }
                )
            })
        },
        // 分页方法
        tableSizeChange: function (pageSize) {
            this.pagination.pageSize = pageSize
            this.getTableData()
        },

        currentChange: function (current) {
            this.pagination.currentPage = current
            this.getTableData();
        },
        // 接收人分页方法
        tableSizeChangePeople: function (pageSize) {
            this.peoplePagination.pageSize = pageSize
            this.getTzPeople(this.tzDetails.uuid)
        },

        currentChangePeople: function (current) {
            this.peoplePagination.currentPage = current
            this.getTzPeople(this.tzDetails.uuid);
        },

        getTableData(initPageFlag) {
            this.loading = true
            let _this = this;
            // 3、 调接口获取数据
            let searchParams = _this.searchForm;
            searchParams.type = '1';
            _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
            let paginationData = _this.FUNCTIONS.systemFunction.paginationSet(
                    initPageFlag ? 1 : _this.pagination.currentPage,
                    initPageFlag ? 10 : _this.pagination.pageSize,
                    searchParams)
            paginationData.baseService = "TGcTztgDetailsServiceImpl",
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                _this.GLOBAL.config.handleType.getPageNew,
                paginationData,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // 结果参数赋值
                        _this.tableData = resultData.obj.records;
                        _this.pagination.pageSize = resultData.obj.size
                        _this.pagination.total = resultData.obj.total
                        _this.pagination.currentPage = resultData.obj.current
                    } else {
                        _this.$message.warning('获取列表数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
        formatterTime(row, column, data) {
            if (!data) {
                return "";
            }
            var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
            return data.replace(reg, "$1-$2-$3 $4:$5:$6");
        },
    },
    mounted() {
        if (this.$route.query) {
            this.searchForm.tztgUuid = this.$route.query.uuid
        }
        this.getTableData('init');
        this.getRoleData();
        this.getAreaData();
    },
    created () {
    },
    watch: {
        $route (to, from){
            if (to.path === '/noticeDetail') {
                console.log('11111111')
            }
        }
    }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/notice/NoticeDetailTable.vue